module.exports = __webpack_public_path__ + "img/Logo3-108.eae4fc16.png";